export default async function (records)
{
	return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view td:nth-child(5) { text-align: right; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Código</th>
					<th data-index="3" data-visible="${this.visible[2]}">Rótulo</th>
					<th data-index="4" data-visible="${this.visible[3]}">Ordem</th>
					<th data-index="5" data-visible="${this.visible[4]}">Inativo</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record =>
				`<tr data-id='${JSON.stringify([record.company_id, record.code])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.code]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${(record.code ?? '').toString()}</td>
					<td data-visible='${this.visible[2]}'>${(record.label ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${record.sort_order ?? ''}</td>
					<td data-visible='${this.visible[4]}'>${record.is_disabled ? 'Sim' : ''}</td>
				</tr>`
			))).join('') + `
			</tbody>
		</table>
	`;
}
